import React, { useState } from "react";
import axios from "axios";
import AlvnaBrand from "../components/AlvnaBrand";
import { endpoints } from "../apiConfig";
import { colors, fonts, space, radius, buttonPrimary, inputBase } from "../theme";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showForgot, setShowForgot] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    try {
      const res = await axios.post(endpoints.adminLogin, { email, password });
      localStorage.setItem("admin_token", res.data.access_token);
      window.location.href = "/admin";
    } catch (err) {
      setError(err.response?.data?.error || "Login failed.");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <AlvnaBrand variant="full" />
        <form onSubmit={handleLogin} style={styles.form}>
          <h2 style={styles.heading}>Alvna Admin Login</h2>
          {error && <div style={styles.error}>{error}</div>}
          <input
            style={styles.input}
            type="email"
            placeholder="Admin email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button style={styles.button} type="submit">Log In</button>
          <div style={{ textAlign: "center" }}>
            <button type="button" style={styles.linkBtn} onClick={() => setShowForgot(true)}>
              Forgot password?
            </button>
          </div>
          <p style={styles.hint}>
            First time here? Use the one-time setup page at
            <br /><code>/backend/setup/create-admin.php</code>
          </p>
        </form>
      </div>

      {showForgot && <ForgotPasswordModal onClose={() => setShowForgot(false)} />}
    </div>
  );
}

function ForgotPasswordModal({ onClose }) {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    await axios.post(endpoints.adminForgotPassword, { email });
    setSent(true);
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        <div style={styles.modalHeader}>
          <strong style={{ fontFamily: fonts.display }}>Forgot Password</strong>
          <button style={styles.closeBtn} onClick={onClose}>×</button>
        </div>
        <div style={{ padding: space[4] }}>
          {sent ? (
            <p style={{ fontFamily: fonts.body, color: colors.textPrimary }}>
              If that email is registered, a reset link has been sent. Check your inbox.
            </p>
          ) : (
            <form onSubmit={submit} style={styles.form}>
              <input
                style={styles.input}
                type="email"
                placeholder="Your admin account email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <button style={styles.button} type="submit">Send Reset Link</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: colors.bgPage,
    padding: space[4],
    boxSizing: "border-box",
  },
  card: {
    width: "100%",
    maxWidth: 380,
    background: colors.surface,
    borderRadius: radius.lg,
    boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
    overflow: "hidden",
  },
  form: { display: "flex", flexDirection: "column", gap: space[3], padding: space[5] },
  heading: { margin: "0 0 4px", fontFamily: fonts.display, fontSize: 19, fontWeight: 600, textAlign: "center", color: colors.textPrimary },
  input: inputBase,
  button: buttonPrimary,
  linkBtn: { background: "none", border: "none", color: colors.brandBlue, cursor: "pointer", fontSize: 13, fontFamily: fonts.body },
  error: { color: "#b91c1c", fontSize: 13, textAlign: "center", fontFamily: fonts.body },
  hint: { fontSize: 11, color: colors.textMuted, textAlign: "center", marginTop: 6, lineHeight: 1.5, fontFamily: fonts.body },
  overlay: {
    position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)",
    display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000,
  },
  modal: { width: 360, maxWidth: "calc(100vw - 24px)", background: colors.surface, borderRadius: radius.md, overflow: "hidden" },
  modalHeader: {
    display: "flex", justifyContent: "space-between", alignItems: "center",
    padding: `${space[3]} ${space[4]}`, borderBottom: `1px solid ${colors.border}`,
  },
  closeBtn: { background: "none", border: "none", fontSize: 20, cursor: "pointer" },
};
